<div
  class="xi-modal__container widget-group-create__container"
  *transloco="let t; read: 'dashboard-options-component'"
>
  <h2 class="xi-modal__title">{{ t('create-alias-dialog.create-alias') }}</h2>

  <div class="xi-modal__content">
    <div class="xi-input-field-wrapper">
      <xi-input-field
        placeholder="{{ t('create-alias-dialog.placeholder') }}"
        label="{{ t('create-alias-dialog.label') }}"
        name="aliasName"
        [(ngModel)]="name"
        required
        [prePopulateStatus]="true"
        [status]="nameStatus"
        (onChange)="nameValidator$.next(name)"
        appAutoFocus="xiInput"
      ></xi-input-field>

      @if (isLoading.validation) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>

    <div class="locked-switch-and-info">
      <xi-toggle-switch
        color="CX"
        [label]="t('create-alias-dialog.shareable')"
        [isLabelInline]="false"
        title="{{ t('create-alias-dialog.shareable') }}"
        (onToggle)="shareable = $event.detail.isToggled"
      ></xi-toggle-switch>
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    <div class="xi-loader-button-container">
      <xi-default-button
        text="{{ t('create-alias-dialog.create') }}"
        buttonSize="large"
        [disabled]="!canCreate()"
        (onClick)="create()"
      ></xi-default-button>

      @if (isLoading.save) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="100"
            [width]="100"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  </div>
</div>
